import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import {INVITE__24} from '@homeaway/svg-defs';

import {namedEvents} from '../../utils/edap';

const signUpRE = /(def%26service%3D){1}(.*\.com)?.*/;

function SignUp({items, travelerLoginClickHandler, signUpLabel}) {
    // if there are no links then render nothing
    if (!items) {
        return null;
    }

    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);

    const edapTrigger = () => {
        const field = {
            actionlocation: 'header.signup'
        };
        context.trigger(namedEvents.HEADER_LINK_CLICK, field);
    };

    const getSignupData = (signup) => {
        return signup.find((item) => item.cssClass.includes('traveler'));
    };

    function createSignupHandler(item) {
        return (event) => {
            if (!item.link) {
                return;
            }

            edapTrigger(item);

            if (travelerLoginClickHandler) {
                event.stopPropagation();
                event.preventDefault();
                travelerLoginClickHandler();
                return;
            }

            let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

            // if login, perform specific link update
            let newLink = item.link.replace(
                signUpRE,
                `$1${doubleEncodedURI}&kmsi=true`
            );

            /* istanbul ignore else */
            if (newLink !== item.link) {
                event.stopPropagation();
                event.preventDefault();
                window.location.assign(newLink);
            }
        };
    }

    const signUp = getSignupData(items);

    return (
        <a className="site-header-nav__link" data-bypass="true" href={signUp.link} onClick={createSignupHandler(signUp)} rel="nofollow">
            <div className="site-header-nav__signup">
                <SVGIcon inlineFlex markup={INVITE__24}/><span className="site-header-nav__icon-label">{signUpLabel}</span>
            </div>
        </a>
    );
}

SignUp.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape),
    travelerLoginClickHandler: PropTypes.func,
    signUpLabel: PropTypes.string
};

export {SignUp};
